import {
  SimpleForm,
  SimpleFormProps,
  TextInput,
  email,
  minLength,
  required
} from 'react-admin';

interface UsersFormProps extends Partial<SimpleFormProps> {
  isCreate?: boolean;
}

export default function UsersForm({ isCreate, ...props }: UsersFormProps) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        autoComplete="off"
        label="Nome"
        source="name"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        autoComplete="off"
        label="E-mail"
        source="email"
        validate={[required(), email()]}
      />

      {isCreate && (
        <TextInput
          fullWidth
          autoComplete="new-password"
          type="password"
          label="Senha"
          source="password"
          validate={[required(), minLength(6)]}
        />
      )}
    </SimpleForm>
  );
}
